import React, { Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  colors,
  Avatar,
  Link,
  Icon,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Chip,
  Button
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";
import { RiPrinterLine } from "react-icons/ri";
import { ImFilePdf } from "react-icons/im";
import { FaMoneyBillWave } from "react-icons/fa";
import { PinDrop } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  inday: {
    color: colors.green[600]
  },
  cpclate: {
    color: colors.red[600]
  },
  cpalate: {
    color: colors.red[600]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    if (value == '') {
      return 'Não Definido'
    } else {
      return value;
    }
  }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const getIconColor = (item) => {
  if (item.rlz == 3) {
    return { color: colors.green[600] }
  } else if (item.sxc || item.hsv || item.dca || item.dia) {
    return { color: colors.yellow[600] }
  } else {
    return { color: colors.red[600] }
  }
}

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, openExportDialog, openPrint, openMapaRota, slas, data, printItem }) => {

  const classes = useStyles();

  return (
    <Fragment>

      <Grid
        item
        lg={12}
        md={12}
        xs={12}
      >
        <Card className={classes.root} style={{ height: '100%' }}>

          <CardHeader variant="h5"
            avatar={
              <Avatar className={classes.avatar}>
                {<Icon component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
              </Avatar>
            }
            title={
              <Grid container spacing={1} >
                <Grid item xs={8}>
                  <Typography
                    component="span"
                    variant="h5"
                    color="textPrimary">
                    <b>{item.nome}</b>
                  </Typography>
                  <Typography
                    component="span"
                    variant="h5"
                    style={{ color: 'blue' }}>
                    <b>&nbsp;({item.ocorrencias.length})</b>
                  </Typography>
                  <br></br>
                  <Typography
                    component="span"
                    variant="h5"
                    color="textPrimary">
                    <b>{(item.auxiliar === item.nome) ? "" : (item.auxiliar) ? `${'e ' + item.auxiliar}` : ""}</b>
                  </Typography>
                </Grid>
                <Grid item xs="auto">
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    startIcon={<RiPrinterLine />}
                    onClick={() => { printItem(item) }}>
                    Imprimir
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    startIcon={<ImFilePdf />}
                    onClick={() => { openPrint(item) }}>
                    Gerar Ordens de Atendimento
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    startIcon={<PinDrop />}
                    onClick={() => { openMapaRota(item) }}>
                    Mapa
                  </Button>
                </Grid>
              </Grid>
            }

          />
          <Divider></Divider>
          <CardContent>
            <TableContainer component={PerfectScrollbar}>
              <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell width={280}>
                      Agência
                    </TableCell>
                    <TableCell width={100}>
                      Ocorrência
                    </TableCell>
                    <TableCell width={20}>
                      Tipo
                    </TableCell>
                    <TableCell width={20}>
                      Hora
                    </TableCell>
                    <TableCell width={120}>
                      Veículo
                    </TableCell>
                    <TableCell>
                      Datas
                    </TableCell>
                    <TableCell>
                      Descrição
                    </TableCell>
                    <TableCell>
                      Observação
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.ocorrencias.map((agendamento) => (
                    <TableRow hover key={agendamento.id} className={classes.root}>
                      <TableCell>
                        <Box
                          noWrap="true"
                          alignItems="center"
                          display="flex"
                        >
                          {(agendamento.rat != null) && (agendamento.rat != 0) ? <Typography style={{ marginLeft: -14, marginTop: -14, fontSize: '10px', color: colors.blue[500] }} >RAT.</Typography> : ""}
                          {(agendamento.orc != null) ? (agendamento.orc > 0) ? <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, marginTop: 5, width: '16px', color: colors.green[500] }} ></Icon> : <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, marginTop: 5, width: '16px', color: colors.red[500] }} ></Icon> : ""}
                          <Avatar
                            className={classes.avatar}
                          >
                            <Icon component={RiAlarmWarningFill} style={getIconColor(agendamento)} ></Icon>
                          </Avatar>
                          {agendamento.codigo} - {agendamento.agencia}
                        </Box>
                        <Box mt={2} >
                        </Box>

                      </TableCell>
                      <TableCell>
                        <Box
                          noWrap="true"
                          alignItems="center"
                          display="flex"
                          component={Link}
                          onClick={() => { openEdition(agendamento) }}
                        >
                          {'OT: ' + agendamento.ot}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip variant="outlined" size='small' label={agendamento.tpo} style={{ backgroundColor: agendamento.cor, color: (agendamento.cor == 'yellow' ? 'black' : 'white') }}>
                        </Chip>
                      </TableCell>
                      <TableCell>
                        {agendamento.hr}
                      </TableCell>
                      <TableCell>
                      {agendamento.vei} {agendamento.vin}
                      </TableCell>
                      <TableCell noWrap={true} width={40}>
                        ABR:.{formatDate(agendamento.abr)}<br></br>
                        CPA:.{formatDate(agendamento.cpa)}-{agendamento.hcpa}<br></br>
                        CPC:.{formatDate(agendamento.cpc)}-{agendamento.hcpc}<br></br>
                        ATD:.{formatDate(agendamento.dia)}<br></br>
                        CON:.{formatDate(agendamento.dca)}
                      </TableCell>
                      <TableCell>
                        {agendamento.dsc}
                      </TableCell>
                      <TableCell>
                        {agendamento.obs}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          </CardContent>

        </Card>

      </Grid>

    </Fragment >
  );
}

export default Record;